import { usd } from "../../dashboard/api";

const ROWS = [[1, 2, 3], [4, 5, 6, 7, 8, 9, 10], [11, 12]];

export const MatrixNodes = ({ slotsFilled = 0, size = "md" }) => {
    const dim = size === "lg" ? "h-11 w-11 text-xs" : "h-8 w-8 text-[10px]";
    return (
        <div className="space-y-2.5" data-testid="matrix-nodes">
            {ROWS.map((row, ri) => (
                <div key={ri} className="flex justify-center gap-2.5">
                    {row.map((n) => {
                        const filled = n <= slotsFilled;
                        const recycle = n >= 11;
                        return (
                            <div key={n} className="group relative">
                                <div
                                    className={`flex items-center justify-center rounded-lg border font-extrabold tabular transition-colors duration-200 ${dim} ${
                                        filled
                                            ? "border-nx-lime/50 bg-nx-lime/15 text-nx-lime"
                                            : recycle
                                              ? "border-dashed border-white/15 bg-nx-soft text-nx-mute"
                                              : "border-white/10 bg-nx-soft text-nx-mute"
                                    }`}
                                    data-testid={`matrix-node-${n}`}
                                >
                                    {n}
                                </div>
                                <div className="pointer-events-none absolute -top-8 left-1/2 z-10 hidden -translate-x-1/2 whitespace-nowrap rounded-md border border-white/10 bg-nx-elev px-2.5 py-1 text-[10px] font-bold text-nx-sub group-hover:block">
                                    Slot {n} · {filled ? "Filled" : recycle ? "Recycle" : "Empty"}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

export const SlotProgress = ({ filled, total }) => (
    <div>
        <div className="flex items-center justify-between text-[10px] font-bold uppercase tracking-[0.16em] text-nx-mute">
            <span>Slots Filled</span>
            <span className="tabular text-nx-sub">{filled} / {total}</span>
        </div>
        <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-nx-soft">
            <div className="h-full rounded-full bg-nx-lime transition-[width] duration-500" style={{ width: `${(filled / total) * 100}%` }} />
        </div>
    </div>
);

export const levelPrice = (level) => usd(level.price, level.price % 1 !== 0 ? 2 : 0);
